<template>
	<div class="full field_container flex">
		<div class="form_container">
			<div style="margin-bottom: 20px;width: 300px;">
				<el-input size="small" placeholder="" v-model="search" @input="searchButton" clearable>
					<el-button slot="prepend" icon="el-icon-search"></el-button>
				</el-input>
			</div>
			<div class="item_container">
				<div class="item_title">系统字段</div>
				<el-divider></el-divider>
				<div class="flex" style="flex-direction: row;align-items: center;margin-top: 10px;">
					<div style="font-size: 12px;margin-right: 10px;">系统数据：</div>
					<el-checkbox v-model="system.flowstatus" size="mini">流程状态</el-checkbox>
					<el-checkbox v-model="system.auditorstaffid" size="mini">审核状态</el-checkbox>
				</div>
			</div>
		</div>
		<div ref="fieldwrap" class="" style="flex: 1;overflow: auto;position: relative;">
			<el-form class="form_container" label-position="left" :model="form" label-width="100px" size="mini"
				v-if="ports" :inline="false">
				<template v-for="(item,index) in ports">
					<div :key="index" class="item_container"
						v-if="!search || item.attrs.portNameLabel.text.includes(search)">
						<div class="item_title">{{item.attrs.portNameLabel.text}}</div>
						<el-divider></el-divider>
						<el-form-item label="类型:">
							<el-checkbox v-model="form[item.id].visiable">表单显示</el-checkbox>
							<!-- 					<el-checkbox v-model="form[item.id].button">按钮</el-checkbox>
								<el-checkbox v-model="form[item.id].popover">挂载</el-checkbox> -->
						</el-form-item>
						<el-form-item label="组件:" style="width: 300px;">
							<el-select size="mini" v-model="form[item.id].fieldcomponent" placeholder="请选择" clearable>
								<el-option label="inputButton" value="inputButton"></el-option>
								<el-option label="inputNumber" value="inputNumber"></el-option>
								<!-- <el-option label="textarea" value="textarea"></el-option> -->
								<el-option label="popover" value="popover"></el-option>
								<el-option label="select" value="select"></el-option>
								<el-option label="switchs" value="switchs"></el-option>
								<el-option label="slider" value="slider"></el-option>
								<el-option label="calendar" value="calendar"></el-option>
								<el-option label="upload" value="upload"></el-option>
								<el-option label="auth" value="auth"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="默认值:" style="width: 100%;">
							<div style="width: 200px;display: inline-block;">
								<el-input v-model="form[item.id].defaultvalue" v-if="!form[item.id].extra"></el-input>
								<emun v-else-if="form[item.id].extra.componenttype=='emun'" :multiple="false"
									v-model="form[item.id].defaultvalue" v-bind="form[item.id].extra" />
								<datePicker v-else-if="form[item.id].extra.componenttype=='date'"
									v-model="form[item.id].defaultvalue" v-bind="form[item.id].extra" />
							</div>

						</el-form-item>
						<el-form-item label="表单字段配置:" style="width: 100%;">
							<div style="width: 200px;display: inline-block;">
								<el-input readonly v-model="form[item.id].componentParam"></el-input>
							</div>
							<div style="display: inline-block;margin-left: 10px;">
								<el-button size="mini" type="primary"
									@click="editConfig(form[item.id],'componentParam')">编辑
								</el-button>
							</div>
						</el-form-item>
						<el-form-item label="列表字段配置:" style="width: 100%;">
							<div style="width: 200px;display: inline-block;">
								<el-input readonly v-model="form[item.id].listParam"></el-input>
							</div>
							<div style="display: inline-block;margin-left: 10px;">
								<el-button size="mini" type="primary" @click="listParamConfig(form[item.id],item.id)">编辑
								</el-button>
							</div>
						</el-form-item>

					</div>
				</template>

			</el-form>
		</div>
		
		<formfieldConfig ref="formfieldConfig" :currentItem="currentItem" :config="editvalue"  @submit="editsubmit" />
		<listfieldConfig ref="listfieldConfig" :title="listParamtitle" :config="listParamFormJson" :itemtype="itemtype" @submit="listParamSubmit"  />
	</div>

</template>
<style scoped>
	.field_container {
		overflow: hidden;
		flex-direction: column;
		box-sizing: border-box;
		padding: 20px;
	}

	.form_container {
		width: 1100px;
		box-sizing: border-box;
		padding: 10px;
	}

	.item_title {
		font-size: 14px;
		font-weight: bolder;
		margin-bottom: 10px;
	}

	.item_container {
		box-shadow: 0px 0px 6px lightgrey;
		box-sizing: border-box;
		padding: 20px;
		margin-bottom: 20px;
	}
</style>
<script>
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	import formfieldConfig from './config/formfield.vue'
	import listfieldConfig from './config/listfield.vue'
	export default {
		props: {
			graph: {
				default: () => {
					return null
				}
			},
			node: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				system: {
					flowstatus: false,
					auditorstaffid:false
				},
				search: '',
				editvalue: {},
				modalShow: false,
				modaltitle: '',
				listParamModalShow: false,
				listParamtitle: '列表字段',
				currentItem: null,
				currentItemName: '',
				form: {

				},

				listParamForm: {
					show: false,
					search: false,
					importsearch: false,
					penetrate: false,
					statistics: false,
					fixed: false,
					order: 100,
					width: 100,
					formatter: null,
					fieldtype: '',
					statisticsmodel: '',
					sortable: false,
					copycontent:false
				},
				listParamFormJson: {},

				checked: false,
				ports: null,
				nodeData: null,
				demo: '',
				itemtype: '',
				connectededges: []

			}
		},
		created() {
			this.connectededges = this.graph.getConnectedEdges(this.node, {
				incoming: false,
				outgoing: true
			})

		},
		mounted() {
			let form = {}
			this.nodeData = this.node.getData()
			this.nodeData.fields.forEach((item) => {
				if (!form[item.field]) {
					form[item.field] = {}
				}
				form[item.field].visiable = item.visiable !== undefined ? item.visiable : true
				form[item.field].button = item.button !== undefined ? item.button : false
				form[item.field].popover = item.popover !== undefined ? item.popover : false
				form[item.field].defaultvalue = item.defaultvalue !== undefined ? item.defaultvalue : ''
				form[item.field].mountcomponent = item.mountcomponent !== undefined ? item.mountcomponent : ''
				form[item.field].type = item.type !== undefined ? item.type : ''
				form[item.field].fieldcomponent = item.fieldcomponent !== undefined ? item.fieldcomponent : ''
				form[item.field].componentParam = item.componentParam !== undefined ? item.componentParam : ''
				form[item.field].listParam = item.listParam !== undefined ? item.listParam : ''
				this.getDefaultComponent(item.field, form[item.field])
			})
			this.form = form
			this.ports = this.node.getPorts()
			// console.log(this.form)
			if (this.nodeData.systemcolumns) {
				this.nodeData.systemcolumns.forEach((item) => {
					this.system[item] = true
				})
			}

		},
		watch: {

		},
		computed: {

		},

		methods: {
			getDefaultComponent(field, item) {
				item.extra = null
				let edgeobj = this.connectededges.find((edge) => {
					return edge.source.port == field && edge.target.cell == 'a_emun_value'
				})
				if (edgeobj) {
					item.extra = {
						componenttype: 'emun',
						name: edgeobj.data.param.emunName,
						cascader: window.systemMethods.isCascader(edgeobj.data.param.emunName)
					}
				}
				if (field.match(/.*time$/g)) {
					item.extra = {
						componenttype: 'date',
						type: 'date'
					}
				}

				if (field.match(/.*staffid$/g)) {
					let staffselectoptions = [{
						label: '相对位置',
						options: [{
							value: 'currentstaff',
							label: '创建人'
						}]
					}]
					let staffoption = []
					window.systemData.staff.forEach((st) => {
						staffoption.push({
							value: st.id,
							label: st.name
						})
					})
					staffselectoptions.push({
						label: '人员',
						options: staffoption
					})
					item.extra = {
						componenttype: 'emun',
						group: true,
						selectoptions: staffselectoptions
					}
				}
				if (field.match(/.*departmentid/g)) {
					let departmentselectoptions = [{
						label: '相对位置',
						options: [{
							value: 'currentdepartment',
							label: '创建人部门'
						}]
					}]
					let departmentoption = []
					window.systemData.department.forEach((st) => {
						departmentoption.push({
							value: st.id,
							label: st.name
						})
					})
					departmentselectoptions.push({
						label: '部门',
						options: departmentoption
					})
					item.extra = {
						componenttype: 'emun',
						group: true,
						selectoptions: departmentselectoptions
					}
				}
			},
			searchButton() {
				let dom = document.getElementById(this.search)
				if (dom) {
					this.$refs.fieldwrap.scrollTop = dom.offsetTop - 10
				}

			},
			submit() {
				let columns = []
				let systemcolumns = []
				this.nodeData.fields.forEach((item) => {
					item.visiable = this.form[item.field].visiable
					item.button = this.form[item.field].button
					item.popover = this.form[item.field].popover
					item.defaultvalue = this.form[item.field].defaultvalue
					item.mountcomponent = this.form[item.field].mountcomponent
					item.fieldcomponent = this.form[item.field].fieldcomponent
					item.componentParam = this.form[item.field].componentParam
					item.listParam = this.form[item.field].listParam
					if (!item.visiable) {
						this.node.setPortProp(item.field, 'attrs/portBody', {
							opacity: .5,
							fill: "#E4E7ED",
							magnet: true
						})
					} else {
						this.node.setPortProp(item.field, 'attrs/portBody', {
							opacity: 1,
							fill: "#EFF4FF",
							magnet: true
						})
					}
					if (item.listParam) {
						let listParam = JSON.parse(item.listParam)
						if (listParam.show) {
							columns.push(item)
						}
					}

				})
				if (this.system.flowstatus) {
					systemcolumns.push('flowstatus')
				}
				if (this.system.auditorstaffid) {
					systemcolumns.push('auditorstaffid')
				}
				this.nodeData.columns = columns
				this.nodeData.systemcolumns = systemcolumns
				this.node.setData(this.nodeData)
				// console.log(this.nodeData)
				// return {
				// 	group: this.nodeData.group,
				// 	index: this.form.index,
				// 	type: 'change'
				// }
				// this.edge.replaceData(this.form)
				// this.edge.appendLabel(this.form.component)
			},
			
			editConfig(e, name) {
				this.currentItem = e
				this.currentItemName = name
				let value = this.currentItem[this.currentItemName]
				this.editvalue = value != '' ? JSON.parse(value) : {},
				this.$nextTick(()=>{
					this.$refs.formfieldConfig.modal_show()
				})
			
			},
			listParamConfig(e, code) {
				this.listParamtitle = '列表字段（' + code + '）'
				this.currentItem = e
				this.nodeData.fields.forEach((item) => {
					if (item.field == code) {
						this.itemtype = item.type
					}
				})
				let value = this.currentItem.listParam
				value = value != '' ? JSON.parse(value) : {}
				this.listParamFormJson = value
				this.$nextTick(()=>{
					this.$refs.listfieldConfig.modal_show()
				})
			},
			editsubmit(e) {
				if (e && JSON.stringify(e) !== '{}') {
					this.currentItem[this.currentItemName] = JSON.stringify(e)
				} else {
					this.currentItem[this.currentItemName] = ''
				}
				this.modalShow = false
			},
			listParamSubmit(e) {
				let obj = e
				if (JSON.stringify(obj) !== '{}') {
					this.currentItem.listParam = JSON.stringify(obj)
				} else {
					this.currentItem.listParam = ''
				}
				//console.log(obj)
			},
		},
		components: {
			emun,
			datePicker,
			formfieldConfig,
			listfieldConfig
		}
	}
</script>
